import Axios from "../../api/Axios";
const BASE_URL = "DiscountDefinition/";

export const EndpointDiscountDefinition = {
    GetAllDiscountData: "GetAllDiscountData",
    GetProductData: "GetProductData",
    // UpdateDiscountMapping: "UpdateDiscountMapping",
    SaveDiscountHeader: "SaveDiscountHeader",
    UpdateDiscountMapping: "UpdateDiscountMapping",
    ExportData: "ExportData",
    DeleteDiscount : "DeleteDiscount",
    SaveData: "SaveData",
    ProdValidation : "ProdValidation",
    GetExistingDisc : "GetExistingDisc"
};
export const createAPIEndpointDiscountDefinition = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL+Endpoint, data)
    };
};
